/**
 * Gerenciador de Atualizações Silenciosas e Transparentes (Padrão Alta Disponibilidade)
 * Inspirado nos fluxos de Linear, Notion e Figma.
 * 
 * 1. Atualiza silenciosamente no background (autoUpdate).
 * 2. Recupera automaticamente de erros de chunk desatualizado (vite:preloadError) sem travar a tela.
 * 3. Nunca interrompe videochamadas ou preenchimento de dados clínicos.
 */

export function setupAutoUpdateManager() {
  if (typeof window === 'undefined') return;

  // 1. Tratamento transparente de Chunks atualizados após novo deploy
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    console.warn('[AutoUpdate] Novo deploy detectado. Atualizando página de forma transparente...');

    const lastReload = sessionStorage.getItem('last_auto_preload_reload');
    const now = Date.now();

    // Evita loop de recarregamento (mínimo de 10 segundos entre recargas)
    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
      sessionStorage.setItem('last_auto_preload_reload', now.toString());
      
      // Se não estiver em videochamada ativa, recarrega suavemente
      if (!window.location.pathname.startsWith('/video-room')) {
        window.location.reload();
      }
    }
  });

  // 2. Transição suave de Service Worker em background
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // Quando um novo service worker assume, não interrompe se estiver em sala de vídeo
      if (!window.location.pathname.startsWith('/video-room')) {
        console.log('[AutoUpdate] Nova versão ativa em segundo plano.');
      }
    });
  }
}
